import tw, { styled } from 'twin.macro';
import { ImageElement } from '@kontent-ai/gatsby-components';

export const StyledLinksWrapper = styled.div`
  ${tw`flex flex-col`}
  ${tw`gap-[12px]`}
  ${tw`pb-1`}
`;

export const StyledHeadingWrapper = styled.div`
  ${tw`p-1`}
`;

export const StyledImage = styled(ImageElement)`
  ${tw`w-full lg:w-[272px]`}
  ${tw`rounded-lg`}
`;

export const StyledSubheadline = styled.p`
  ${tw`font-poppins font-semi-bold`};
  ${tw`text-tag-l text-primary-p1`}
  ${tw`pb-1`}
  ${tw`mb-1`}
  ${tw`border-b border-ui-colours-ui3`}
`;
